/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeSystemBlockValidationTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   System Block Validation Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, September 24, 2018 - 6:34 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/24/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const SYSTEMBLOCKVALIDATIONTYPE_LIST_CONTAINER_LOADED = 'SYSTEMBLOCKVALIDATIONTYPE_LIST_CONTAINER_LOADED';
export const SYSTEMBLOCKVALIDATIONTYPE_LIST_CONTAINER_UNLOADED = 'SYSTEMBLOCKVALIDATIONTYPE_LIST_CONTAINER_UNLOADED';
export const SYSTEMBLOCKVALIDATIONTYPE_LIST_TABLE_LOADED = 'SYSTEMBLOCKVALIDATIONTYPE_LIST_TABLE_LOADED';
export const SYSTEMBLOCKVALIDATIONTYPE_LIST_TABLE_UNLOADED = 'SYSTEMBLOCKVALIDATIONTYPE_LIST_TABLE_UNLOADED';
export const SYSTEMBLOCKVALIDATIONTYPE_SELECT_ROW = 'SYSTEMBLOCKVALIDATIONTYPE_SELECT_ROW';
export const SYSTEMBLOCKVALIDATIONTYPE_ADD = 'SYSTEMBLOCKVALIDATIONTYPE_ADD';
export const SYSTEMBLOCKVALIDATIONTYPE_EDIT = 'SYSTEMBLOCKVALIDATIONTYPE_EDIT';
export const SYSTEMBLOCKVALIDATIONTYPE_DELETE = 'SYSTEMBLOCKVALIDATIONTYPE_DELETE';
export const SYSTEMBLOCKVALIDATIONTYPE_OPEN_WARNING = 'SYSTEMBLOCKVALIDATIONTYPE_OPEN_WARNING';
export const SYSTEMBLOCKVALIDATIONTYPE_CLOSE_WARNING = 'SYSTEMBLOCKVALIDATIONTYPE_CLOSE_WARNING';
export const SYSTEMBLOCKVALIDATIONTYPE_VIEW_FIELDS = 'SYSTEMBLOCKVALIDATIONTYPE_VIEW_FIELDS';
export const SYSTEMBLOCKVALIDATIONTYPE_DELETE_DISABLE = 'SYSTEMBLOCKVALIDATIONTYPE_DELETE_DISABLE';

export const SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_LOADED = 'SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_LOADED';
export const SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_UNLOADED = 'SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_UNLOADED';
export const SYSTEMBLOCKVALIDATIONTYPE_EDIT_FORM_LOADED = 'SYSTEMBLOCKVALIDATIONTYPE_EDIT_FORM_LOADED';
export const SYSTEMBLOCKVALIDATIONTYPE_EDIT_FORM_UNLOADED = 'SYSTEMBLOCKVALIDATIONTYPE_EDIT_FORM_UNLOADED';
export const SYSTEMBLOCKVALIDATIONTYPE_EDIT_DATA_LOAD = 'SYSTEMBLOCKVALIDATIONTYPE_EDIT_DATA_LOAD';
export const SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_SUBMIT = 'SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_SUBMIT';
export const SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_CANCEL = 'SYSTEMBLOCKVALIDATIONTYPE_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeSystemBlockValidationTypes.js